<template>
  <ValidationProvider :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group slot-scope="{ valid, errors }" v-bind="$attrs">
      <b-form-checkbox v-model="innerValue" v-bind="$attrs" value="true" unchecked-value="false">
        {{ $attrs.label }}
      </b-form-checkbox>

      <b-form-invalid-feedback id="inputLiveFeedback">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { BFormGroup, BFormInvalidFeedback, BFormCheckbox } from 'bootstrap-vue';
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
    BFormGroup,
    BFormInvalidFeedback,
    BFormCheckbox,
  },
  props: {
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
